import { actionTypes } from "./constants";
const initialState = {
  projectList:{
    list:[],
    total:0,
    stats: null,
  },
  productList: {
    list:[],
    total:0,
  },
  industryTypeList: {
    list:[],
    total:0,
  },
  productSelectList:[],
  forecastCategoryList: {
    list: [],
    total: 0,
  },
  projectStatusList: {
    list: [],
    total: 0,
  },
  constantList: {
    rows: [],
    count: 0,
  },
  projectLog: [],
  projectChangePageList: {
    rows: [],
    count: 0,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROJECT_LIST:
      return {
        ...state, projectList: action.data,
      };
    case actionTypes.SET_PRODUCT_LIST:
      return {
        ...state, productList: action.data,
      };
    case actionTypes.SET_PRODUCT_SELECT_LIST:
      return {
        ...state, productSelectList: action.data,
      };
    case actionTypes.SET_INDUSTRY_TYPE_LIST:
      return {
        ...state, industryTypeList: action.data,
      };
    case actionTypes.SET_FORECAST_CATEGORY:
      return {
        ...state, forecastCategoryList: action.data,
      };
    case actionTypes.SET_PROJECT_STATUS:
      return {
        ...state, projectStatusList: action.data,
      };
    case actionTypes.SET_CONSTANT_LIST:
      return {
        ...state, constantList: action.data,
      };
    case actionTypes.SET_PROJECT_LOG:
      return {
        ...state, projectLog: action.data,
      };
    case actionTypes.SET_PROJECT_CHANGE_PAGE_LIST:
      return {
        ...state, projectChangePageList: action.data,
      };
    default:
      return state;
  }
};

export default reducer;
